<script lang="ts">
  import { enPropriétéWebC } from '$plateforme/webComponent';
  import Accordeon from '../ui/Accordeon.svelte';
  import Lien from '../ui/Lien.svelte';

  const tags = [
    { id: 'Administrations publiques', label: 'Administrations publiques', icon: 'bank-line' },
    { id: 'Eaux potables', label: 'Eaux potables', icon: 'drop-line' },
    { id: 'Eaux non potables', label: 'Eaux non potables', icon: 'blur-off-line' },
    { id: 'Énergies', label: 'Énergies', icon: 'flashlight-line' },
    { id: 'Espace', label: 'Espace', icon: 'contrast-line' },
    {
      id: "Gestion des services Technologies de l'information et de la Communication (interentreprises)",
      label: "Gestion des services Technologies de l'information et de la Communication (interentreprises)",
      icon: 'chat-settings-line',
    },
    {
      id: 'Infrastructures des marchés financiers',
      label: 'Infrastructures des marchés financiers',
      icon: 'line-chart-line',
    },
    { id: 'Infrastructures numériques', label: 'Infrastructures numériques', icon: 'mac-line' },
    { id: 'Santé', label: 'Santé', icon: 'heart-pulse-line' },
    { id: 'Secteur bancaire', label: 'Secteur bancaire', icon: 'bank-card-line' },
    { id: 'Transport', label: 'Transport', icon: 'bus-line' },
  ];
  const autreTags = [
    {
      id: 'Fabrication, production et distribution de produits chimiques',
      label: 'Fabrication, production et distribution de produits chimiques',
      icon: 'paint-line',
    },
    { id: 'Fournisseurs numériques', label: 'Fournisseurs numériques', icon: 'macbook-line' },
    { id: 'Gestion des déchets', label: 'Gestion des déchets', icon: 'recycle-line' },
    { id: 'Industries manufacturières', label: 'Industries manufacturières', icon: 'settings-5-line' },
    {
      id: 'Production, transformation et distribution de denrées alimentaires',
      label: 'Production, transformation et distribution de denrées alimentaires',
      icon: 'restaurant-line',
    },
    {
      id: 'Recherche',
      label: 'Recherche',
      icon: 'microscope-line',
    },
    { id: 'Services postaux et d’expédition', label: 'Services postaux et d’expédition', icon: 'mail-send-line' },
  ];
</script>

<div class="accordeons">
  <Accordeon niveauTitre={3} libelle="18 secteurs d'activités concernés">
    <p>
      Plusieurs milliers d'entités réparties sur 18 secteurs d'activité seront concernés. Pour l'essentiel, ces entités
      seront des moyennes et grandes entreprises ainsi que des collectivités territoriales et des administrations.
    </p>

    <h4>Secteurs hautement critiques</h4>
    <dsfr-tags-group size="md" group-markup="ul" has-icon="true" tags={enPropriétéWebC(tags)}>
      <ul slot="seo">
        {#each tags as tag (tag.id)}
          <li>{tag.label}</li>
        {/each}
      </ul>
    </dsfr-tags-group>

    <h4>Autres secteurs critiques</h4>
    <dsfr-tags-group size="md" group-markup="ul" has-icon="true" tags={enPropriétéWebC(autreTags)}>
      <ul slot="seo">
        {#each autreTags as tag (tag.id)}
          <li>{tag.label}</li>
        {/each}
      </ul>
    </dsfr-tags-group>
  </Accordeon>

  <Accordeon niveauTitre={3} libelle="2 typologies d’entités : Essentielles (EE) et Importantes (EI)">
    <p>
      Deux types d’entités relevant des secteurs précités sont concernées par la directive NIS2, définies, selon leur
      degré de criticité, leur taille et leur chiffre d’affaires (pour les entreprises)&nbsp;:
    </p>
    <ul>
      <li>
        <strong>Les entités essentielles</strong>, si elles emploient au moins 250 personnes ou ont un chiffre
        d’affaires annuel supérieur à 50 millions d’euros et un bilan annuel supérieur à 43 millions d’euros&nbsp;;
      </li>
      <li>
        <strong>Les entités importantes</strong>, si elles ne sont pas entités essentielles et emploient au moins 50
        personnes ou ont un chiffre d’affaires et un bilan annuel supérieur à 10 millions d’euros.
      </li>
    </ul>
    <p>
      La directive NIS2 prévoit des exceptions pour plusieurs types d’entité, dont les prestataires de services de
      confiance, les fournisseurs de services DNS, les registres de noms de domaine de premier niveau, les fournisseurs
      de réseaux de communications électroniques publiques, les fournisseurs de services de communications électroniques
      accessibles au public et l’administration publique. <Lien
        libelle="En savoir plus"
        href="https://aide.monespacenis2.cyber.gouv.fr/fr/"
        blank
      />
    </p>
  </Accordeon>

  <Accordeon niveauTitre={3} libelle="3 obligations majeures">
    <h6>L’enregistrement auprès de l’autorité nationale compétente</h6>
    <p>
      Une fois qu’une entité a évalué qu’elle entrait dans le périmètre de la directive NIS&nbsp;2, celle-ci doit
      s’enregistrer en France auprès de l’Agence nationale de la sécurité des systèmes d’information (ANSSI).
    </p>
    <Lien
      libelle="Pré-enregistrer mon entité"
      href="https://club.ssi.gouv.fr/#/nis2/introduction"
      blank
      iconeADroite
      icone="external-link-line"
      apparence="bouton"
    />
    <h6>La gestion des risques cyber</h6>
    <p>
      Les entités concernées par la directive NIS2 sont tenues de mettre en place des mesures juridiques, techniques et
      organisationnelles visant à gérer les risques qui menacent la sécurité de leurs réseaux et de leurs systèmes
      d’information. <Lien libelle="En savoir plus" href="https://aide.monespacenis2.cyber.gouv.fr/fr/" blank neutre />
    </p>
    <p>
      Afin de les aider, l'ANSSI a conçu le <Lien libelle="Référentiel Cyber France" href="/nis2#exigences" neutre /> (ReCyF)
      qui liste les mesures recommandées par l’ANSSI pour atteindre les objectifs de sécurité fixés par NIS 2. Compte tenu
      du niveau de la menace cybercriminelle, et pour permettre aux organisations d’initier dès à présent une démarche de
      sécurisation cohérente avec NIS 2, l’ANSSI a décidé de rendre public <Lien
        libelle="une version de travail du Référentiel Cyber France"
        neutre
        href="/documents-ressources/20260317_NIS_V2_ReCyF_v2.5.pdf"
      />
      (ReCyF) qui a pour vocation de devenir le socle de la réglementation cyber française. ReCyF est susceptible d’ajustements
      pour tenir compte des discussions parlementaires et des travaux règlementaires à venir.
    </p>
    <p>
      En raison de la nature transfrontalière de leurs services, certaines entités du secteur des infrastructures
      numériques, de gestion des services des technologies de l’information et de la communication (TIC) et des
      fournisseurs numériques font l’objet d’un règlement d’exécution spécifique de la Commission européenne (<Lien
        libelle="accessible en français ici"
        href="https://eur-lex.europa.eu/legal-content/FR/TXT/PDF/?uri=OJ:L_202402690"
        blank
        neutre
      />). Par conséquent, elles ne sont pas soumises au socle de mesures de sécurité NIS 2 définies pour les entités
      établies en France. <Lien
        libelle="En savoir plus"
        href="https://aide.monespacenis2.cyber.gouv.fr/fr/"
        blank
        neutre
      />
    </p>
    <Lien
      libelle="Découvrir les solutions pour m’aider"
      type="secondaire"
      href="/nis2#solutions&comprendre"
      apparence="bouton"
    ></Lien>
    <h6>La déclaration d’incidents</h6>
    <p>
      Les entités concernées par NIS2 devront, par ailleurs, signaler à l’ANSSI leurs incidents de sécurité ayant un
      impact important et fournir des rapports concernant l’évolution de la situation.
    </p>
    <Lien
      libelle="Déclarer un incident"
      type="secondaire"
      href="https://club.ssi.gouv.fr/#/declarations"
      blank
      iconeADroite
      icone="external-link-line"
      apparence="bouton"
      classe="action-declaration-incident"
    ></Lien>
    <p>
      Conformément à la directive NIS&nbsp;2, des actions de supervision seront assurées pour vérifier le respect par
      les entités de leurs obligations. En cas de non-respect de ces dernières, les entités s’exposeront à des
      sanctions. La directive prévoit la capacité d’imposer, entre autres, des sanctions financières aux entités
      régulées. Ces sanctions, qui doivent être proportionnées au(x) manquement(s), pourront aller jusqu’à un
      pourcentage du chiffre d’affaires mondial des entités (2&nbsp;% pour les EE et 1,4&nbsp;% pour les EI).
    </p>
  </Accordeon>
</div>

<style lang="scss">
  .accordeons {
    display: flex;
    flex-direction: column;
    margin: 2rem 0;

    h6:not(:first-child) {
      margin-top: 1.5rem;
    }
  }

  :global(dsfr-button.action-declaration-incident) {
    margin-bottom: 2rem;

    + p {
      margin-top: 0;
    }
  }
</style>
